<template>
  <expansion-panel
    name="cutPdf"
    ref="ztExpansionPanelCrop"
    :title="$t('message.abm.folders.toolbox.cut')"
    prepend-icon="crop-outline"
    :disabled="disabled"
    :auto-collapse="false"
    @handleClick="setFocusPanel"
    @open="shownSignatureCutTool"
  >
    <div>
      <p class="text-zt-dark-300 mb-4 font-125">{{ $t('message.abm.folders.toolbox.cutPdf') }}</p>
      <zt-button
        class="setting-button mb-4"
        outlined
        :loader-txt="$t('message.abm.folders.toolbox.applying')"
        :loader="isLoading"
        @click="sendCutSettings"
        data-vs-button="sendCutSettings"
      >
        <span v-if="!applied">{{ $t('message.abm.folders.toolbox.applyCut') }}</span>
        <span v-if="applied">{{ $t('message.abm.folders.toolbox.cutDone') }}</span>
        <zt-icon v-if="applied" name="check" />
      </zt-button>
      <p
        v-if="applied"
        class="text-zt-dark-400 mt-2 underline cursor-pointer inline-block"
        @click="clear"
        data-vs-button="clear"
      >
        {{ $t('message.abm.folders.toolbox.undo') }}
      </p>
      <div
        v-show="showDeleteBox"
        ref="warningDeleteBox"
        class="absolute bg-white rounded position-box box-deleted p-4 flex flex-column"
        :style="cordsDeleteBox"
      >
        <p class="font-medium mb-3">
          {{ $t('message.abm.folders.toolbox.undoTitle') }}
        </p>
        <p class="text-zt-dark-300 text-zt-base">
          {{ $t('message.abm.folders.toolbox.questionUndo') }}
        </p>
        <div class="flex justify-end h-full items-end">
          <zt-button text style="color: #4a4a4a !important;" class="text-zt-base" @click="closeBoxDelete" data-vs-button="closeBoxDelete">
            {{ $t('message.abm.folders.toolbox.cancel') }}
          </zt-button>
          <zt-button class="text-zt-base ml-2" @click="clearCutPDF" data-vs-button="clearCutPDF">
            {{ $t('message.abm.folders.toolbox.confirmUndo') }}
          </zt-button>
        </div>
      </div>
    </div>
  </expansion-panel>
</template>
<script>
import ExpansionPanel from '../generic/ExpansionPanel'
export default {
  name: "CutPdfActionPanel",
  components: {
    ExpansionPanel
  },
  inject: [
    'setFilePdf',
    'setFocusPanel',
    'setModalStateProperty',
    'signatureToolApplied'
  ],
  props: {
    disabled: {
      type: Boolean,
      default: true
    },
    preset: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      applied: false,
      cordsDeleteBox: {},
      file: '',
      isLoading: false,
      showDeleteBox: false
    }
  },
  computed: {
    isModified() {
      return this.preset.applied
    }
  },
  watch: {
    showDeleteBox() {
      if (this.showDeleteBox) {
        this.insertContent(this.$refs.warningDeleteBox)
      }
    }
  },
  methods: {
    clear(e) {
      this.showDeleteBox = true
      this.$nextTick(() => {
        this.cordsDeleteBox = this.positionBox(e.target)
      })
    },
    clearCutPDF(){
      this.$emit('clear', 'cutPdf')
      this.closeBoxDelete()
    },
    close() {
      this.$refs.ztExpansionPanelCrop.close()
    },
    closeBoxDelete() {
      this.showDeleteBox = false
      this.deleteContent()
    },
    deleteContent() {
      let [parent] = document.getElementsByTagName('body')
      if (
        parent &&
        this.$refs.warningDeleteBox &&
        this.$refs.warningDeleteBox.parentNode === parent
      ) {
        parent.removeChild(this.$refs.warningDeleteBox)
      }
    },
    insertContent(elz) {
      let content = document.body
      content.insertBefore(elz, content.firstChild)
    },
    positionBox(el) {
      let chipWrapper = el
      let scrollContentTop = window.pageYOffset || document.documentElement.scrollTop
      let topPos = chipWrapper.getBoundingClientRect().top + scrollContentTop - chipWrapper.clientHeight
      let leftPost = chipWrapper.getBoundingClientRect().right + 12
      return {
        left: `${leftPost}px`,
        top: `${topPos}px`
      }
    },
    async sendCutSettings() {
      if (this.applied) return
      this.isLoading = true
      await this.setFilePdf()
      this.isLoading = false
    },
    shownSignatureCutTool(show) {
      this.setModalStateProperty({ show }, 'cutPdf', 'preset')
    }
  },
  beforeDestroy() {
    this.deleteContent()
  }
}
</script>

<style scoped>
.position-box {
  width: 350px;
  height: 176px;
  z-index: 9999;
  box-shadow: 0 0 10px 0 rgba(44, 43, 43, 0.65);
  -webkit-box-shadow: 0 0 10px 0 rgba(44, 43, 43, 0.65);
  -moz-box-shadow: 0 0 10px 0 rgba(44, 43, 43, 0.65);
}
.box-deleted:after {
  content: "";
  background: inherit;
  width: 16px;
  height: 16px;
  position: absolute;
  display: block;
  left: -14px;
  transform: rotate(45deg) translateY(-50%);
  top: 25%;
  border-left: 1px solid #D0D0D0FF;
  border-bottom: 1px solid #D0D0D0FF;
}
</style>
